export default __webpack_public_path__ + "static/media/return-to-fertility-silhouette@2x.2a34a211.png";